import { render, staticRenderFns } from "./manuscript.vue?vue&type=template&id=25da0fc0&scoped=true"
import script from "./manuscript.vue?vue&type=script&lang=js"
export * from "./manuscript.vue?vue&type=script&lang=js"
import style0 from "./manuscript.vue?vue&type=style&index=0&id=25da0fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25da0fc0",
  null
  
)

export default component.exports